import { computed, makeObservable } from 'mobx';

import LazyLoadingKeyValueStore, {
  EventBasedTransport,
} from '@codefluegel/lazy-loading-key-value-store';

export default class ConfigStore extends LazyLoadingKeyValueStore<
  string | number
> {
  constructor(transport: EventBasedTransport<string | number>) {
    super(transport);
    makeObservable(this, {
      linkToMaexchenInfo: computed,
      linkToKnaufNow: computed,
      linkToSystemFinder: computed,
      linkToDataPrivacy: computed,
      fireSafetyFolder: computed,
      reportEmailAddress: computed,
      pointsValidityInMonths: computed,
    });
  }

  private getEntriesString(entryName: string) {
    const value = this.entriesMap.get(entryName);
    return value === undefined ? undefined : value.toString();
  }

  get linkToMaexchenInfo(): string | undefined {
    return this.getEntriesString('linkToMaexchenInfo');
  }

  get linkToKnaufNow(): string | undefined {
    return this.getEntriesString('linkToKnaufNow');
  }

  get linkToSystemFinder(): string | undefined {
    return this.getEntriesString('linkToSystemFinder');
  }

  get linkToDataPrivacy(): string | undefined {
    return this.getEntriesString('linkToDataPrivacy');
  }

  get fireSafetyFolder(): string | undefined {
    return this.getEntriesString('fireSafetyFolder');
  }

  get reportEmailAddress(): string | undefined {
    return this.getEntriesString('reportEmailAddress');
  }

  get pointsValidityInMonths(): number | undefined {
    const value = this.entriesMap.get('pointsValidityInMonths');
    return value === undefined ? undefined : Number(value);
  }

  updateLinkToMaexchenInfo(link: string): Promise<void> {
    return this.updateEntry('linkToMaexchenInfo', link);
  }

  updateLinkToKnaufNow(link: string): Promise<void> {
    return this.updateEntry('linkToKnaufNow', link);
  }

  updateLinkToSystemFinder(link: string): Promise<void> {
    return this.updateEntry('linkToSystemFinder', link);
  }

  updateLinktoDataPrivacy(link: string): Promise<void> {
    return this.updateEntry('linkToDataPrivacy', link);
  }

  updateLinktoFireSafetyFolder(link: string): Promise<void> {
    return this.updateEntry('fireSafetyFolder', link);
  }

  updateReportMailAddress(link: string): Promise<void> {
    return this.updateEntry('reportEmailAddress', link);
  }

  updatePointsValidityInMonths(newPeriod: number): Promise<void> | null {
    return this.updateEntry('pointsValidityInMonths', newPeriod);
  }
}
